import { memo, useState, useEffect } from 'react'
import { Transition } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'

import Form from '@/ui/Form'
import {
  StyledInput,
  IconContainer,
  StyledIcon,
  StyledButton,
  SearchIcon,
} from './Styles'
import { SearchProps } from './types'

const Search = ({
  initialValue = '',
  placeholder,
  handleSubmit,
  hideClearIcon,
  onSearchChange,
  onResultSelect,
  category = false,
  hideSearchButton = false,
  loading = false,
  results,
  ...rest
}: SearchProps) => {
  const { t } = useTranslation()

  const [search, setSearch] = useState('')

  useEffect(() => {
    setSearch(initialValue)
  }, [initialValue])

  const clearSearch = () => {
    setSearch('')
    handleSubmit('')

    if (onSearchChange) {
      onSearchChange('')
    }
  }

  const submit = () => {
    handleSubmit(search)
  }

  return (
    <Form style={{ display: 'flex', position: 'relative' }} onSubmit={submit}>
      {hideSearchButton && <SearchIcon name="icon-search" />}
      <StyledInput
        category={category}
        hideSearchButton={hideSearchButton}
        value={search}
        loading={loading}
        showNoResults={results !== undefined}
        results={results}
        placeholder={placeholder || t('Add search terms')}
        onSearchChange={(e, { value }) => {
          setSearch(value ?? '')

          if (onSearchChange) {
            onSearchChange(value)
          }
        }}
        onResultSelect={(_, { result }) => {
          if (onResultSelect) {
            onResultSelect(result)
          }
          handleSubmit(result.title)
        }}
        {...rest}
      />
      {!hideClearIcon && (
        <Transition visible={!!search.length} duration="200">
          <IconContainer hideSearchButton={hideSearchButton}>
            <StyledIcon
              name="remove"
              color="red"
              onClick={() => clearSearch()}
            />
          </IconContainer>
        </Transition>
      )}
      {!hideSearchButton && <StyledButton type="submit" />}
    </Form>
  )
}

export default memo(Search)
